<template>
  <div>
    <Editor v-model="commentText" placeholder="Gib einen Kommentar ein..." id="editor-input-field" />
    <b-button
      v-if="commentMode === ''"
      size="sm"
      class="mt-2 dialog-btn"
      :variant="commentText.length > 0 ? 'primary' : ''"
      :disabled="commentText.length === 0"
      @click="emitSaveEvent"
    >
      Speichern
    </b-button>
    <div v-if="commentMode === 'edit'" class="d-flex mt-2" style="gap: 8px">
      <b-button size="sm" class="dialog-btn-secondary" @click="emitCancelEditEvent">Abbrechen</b-button>
      <b-button
        size="sm"
        class="dialog-btn"
        :variant="commentText.length > 0 ? 'primary' : ''"
        :disabled="commentText.length === 0"
        @click="emitSaveEditEvent"
      >
        Ändern
      </b-button>
    </div>
    <div v-if="commentMode === 'reply'" class="d-flex mt-2" style="gap: 8px">
      <b-button size="sm" class="dialog-btn-secondary" @click="emitCancelReplyEvent">Abbrechen</b-button>
      <b-button
        size="sm"
        class="dialog-btn"
        :variant="commentText.length > 0 ? 'primary' : ''"
        :disabled="commentText.length === 0"
        @click="emitSaveReplyEvent"
      >
        Antworten
      </b-button>
    </div>
  </div>
</template>
<script>
import Editor from '@/components/common/editor.vue';
import { SET_COMMENT_TEXT } from '@/core/comments/comments.module';
import { mapState } from 'vuex';

export default {
  components: { Editor },
  computed: {
    ...mapState({
      commentMode: state => state.comments.mode,
      users: state => state.users.users,
    }),
    commentText: {
      get() {
        return this.$store.state.comments.commentText;
      },
      set(value) {
        this.$store.commit(SET_COMMENT_TEXT, value);
      },
    },
  },
  methods: {
    emitSaveEvent() {
      this.$emit('save-comment', this.commentText);
    },
    emitCancelEditEvent() {
      this.$emit('cancel-edit');
    },
    emitSaveEditEvent() {
      this.$emit('save-edit-comment', this.commentText);
    },
    emitSaveReplyEvent() {
      this.$emit('save-reply-comment', this.commentText);
    },
    emitCancelReplyEvent() {
      this.$emit('cancel-reply');
    },
  },
};
</script>
<style scoped></style>
